module.exports = __webpack_public_path__ + "img/软件服务.0639da45.jpg";